import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import AuthProvider from './AuthProvider';

async function deferRender() {
    const { worker } = await import('./mocks/browser.js');
    // return worker.start()
}


deferRender().then(() => {
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );
    root.render(
        <React.StrictMode>
                <AuthProvider>
                    <App />
                </AuthProvider>
        </React.StrictMode>
    );
});
